/* ═══════════════════════════════════════════════════════════
   ZEE STYLE — Header JS
   Drawer · Mobile Search · Accordion Nav · Desktop Dropdown
═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Elements ── */
  var drawer       = document.querySelector('[data-drawer]');
  var overlay      = document.querySelector('[data-drawer-overlay]');
  var openBtns     = document.querySelectorAll('[data-drawer-open]');
  var closeBtn     = document.querySelector('[data-drawer-close]');
  var searchToggle = document.querySelector('[data-search-toggle]');
  var mobileSearch = document.querySelector('[data-mobile-search]');

  /* ══════════════════════════════════
     DRAWER
  ══════════════════════════════════ */
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.body.style.overflow = '';
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      openDrawer();
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ══════════════════════════════════
     MOBILE SEARCH TOGGLE
  ══════════════════════════════════ */
  if (searchToggle && mobileSearch) {
    searchToggle.addEventListener('click', function () {
      var isOpen = mobileSearch.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileSearch.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      if (isOpen) {
        var inp = document.getElementById('zMobileSearchInput');
        if (inp) setTimeout(function () { inp.focus(); }, 80);
      }
    });
  }

  /* ══════════════════════════════════
     DRAWER ACCORDION
     Fix: event delegation on drawer nav
     so clicks always register
  ══════════════════════════════════ */
  var drawerNav = document.querySelector('.zdrawer__nav');

  if (drawerNav) {
    drawerNav.addEventListener('click', function (e) {
      /* Find closest accordion button */
      var btn = e.target.closest('[data-accordion]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var isExpanded = btn.getAttribute('aria-expanded') === 'true';
      var subnav = btn.nextElementSibling;

      /* Close all others */
      drawerNav.querySelectorAll('[data-accordion]').forEach(function (b) {
        if (b !== btn) {
          b.setAttribute('aria-expanded', 'false');
          var s = b.nextElementSibling;
          if (s) s.classList.remove('is-open');
        }
      });

      /* Toggle current */
      if (isExpanded) {
        btn.setAttribute('aria-expanded', 'false');
        if (subnav) subnav.classList.remove('is-open');
      } else {
        btn.setAttribute('aria-expanded', 'true');
        if (subnav) subnav.classList.add('is-open');
      }
    });
  }

  /* ══════════════════════════════════
     DESKTOP DROPDOWN — keyboard support
  ══════════════════════════════════ */
  var dropItems = document.querySelectorAll('.znav__item--drop');

  dropItems.forEach(function (item) {
    var link = item.querySelector('.znav__link');
    var drop = item.querySelector('.znav__drop');
    if (!link || !drop) return;

    /* Show on focus */
    link.addEventListener('focus', function () {
      drop.style.display = 'block';
    });

    /* Hide when focus leaves the whole item */
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) {
        drop.style.display = '';
      }
    });

    /* Child links — navigate directly */
    drop.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.stopPropagation();
        window.location.href = a.getAttribute('href');
      });
    });
  });

})();